<div class="modal__content">
    <h2>{{ $t('modals.new.title') }}</h2>
    <div class="form__group">
        <p v-html="$t('modals.new.content')"></p>
    </div>
    <button class="btn btn-green" @click="closeModal('new')">{{ $t('modals.new.next') }}</button>
</div>
